import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
//Ouvre le document pdf dans un nouvel onglet
export class DocumentTabService {
  openLoadingTab(): Window | null {
    const newTab = window.open('', '_blank');

    if (newTab) {
      newTab.document.write(`
        <html>
          <head>
            <title>Chargement du document...</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100vh;
                margin: 0;
                background-color: #f9f9f9;
              }
              .message {
                text-align: center;
              }
            </style>
          </head>
          <body>
            <div class="message">
              <h2>Chargement du document PDF...</h2>
              <p>Veuillez patienter quelques instants.</p>
            </div>
          </body>
        </html>
      `);
    }

    return newTab;
  }

  showError(tab: Window | null): void {
    if (tab) {
      tab.document.body.innerHTML = `
        <h2>Erreur lors du chargement du document.</h2>
        <p>Veuillez réessayer plus tard.</p>
      `;
    }
  }

  redirectToBlob(tab: Window | null, blobUrl: string): void {
    if (tab) {
      tab.location.href = blobUrl;
    }
  }
}
